module.exports = __webpack_public_path__ + "img/person_no_picture.9215d470.svg";